'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');

var ListItemWithIcon = function (props) {
    var _a = props.title, title = _a === void 0 ? '' : _a, _b = props.primaryText, primaryText = _b === void 0 ? '' : _b, secondaryText = props.secondaryText, rightIcon = props.rightIcon, leftIcon = props.leftIcon, handleClick = props.handleClick, narrowListIcon = props.narrowListIcon;
    var leftIconElement = leftIcon && (React__default.createElement(core.ListItemIcon, { style: { minWidth: narrowListIcon ? '40px' : '56px' } }, leftIcon));
    var rightIconElement = rightIcon && React__default.createElement(core.ListItemIcon, null, rightIcon);
    return (React__default.createElement(core.ListItem, { button: true, onClick: handleClick, title: title },
        leftIconElement,
        React__default.createElement(core.ListItemText, { primary: primaryText, secondary: secondaryText }),
        rightIconElement));
};

module.exports = ListItemWithIcon;
